export const cnp = function (value) {
    let regexp = RegExp("^[1-9]\\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\\d|3[01])(0[1-9]|[1-4]\\d|5[0-2]|99)(00[1-9]|0[1-9]\\d|[1-9]\\d\\d)\\d$", 'i');
    return regexp.test(value) || !value;
}

export const email = function (value) {
    let regexp = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/);
    return regexp.test(value) || !value;
}

export const phone = function (value) {
    let regexp = new RegExp(/(07[0-8][0-9]|02[0-9]{2}|03[0-9]{2})([0-9]{3}){2}/);
    return regexp.test(value) || !value;
}

export const series = function (value) {
    let regexp = RegExp("[A-Za-z]{2}",'i');
    return regexp.test(value) || !value;
}

export const idNumber = function (value) {
    let regexp = RegExp("[0-9]{6}");
    return regexp.test(value) || !value;
}

export const cif = function (value) {
    let regexp = RegExp("(RO|RO )?[0-9]{1,9}", 'i');
    return regexp.test(value) || !value;
}

export const civ = function (value) {
    let regexp = RegExp("[a-zA-Z][0-9]{6}", 'i');
    return regexp.test(value) || !value;
}

export const regNr = function (value) {
    let regexp = new RegExp('[A-Z]{1,2}[0-9]{2,3}[A-Z]{3,3}', 'i');
    return regexp.test(value) || !value;
}

export const todayOrLater = function (value) {
    var now = new Date();
    now.setHours(0,0,0,0);

    var date = new Date(value);
    date.setHours(0, 0, 0, 0);

    return date >= now;
}
